// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-icon-input-icon-input-styles__leftIcon {
  left: 12px;
  top: 0;
  position: absolute;
  z-index: 2;
  padding-top: 4px;
}

.src-icon-input-icon-input-styles__rightIcon {
  right: 12px;
  top: 0;
  position: absolute;
  z-index: 2;
  padding-top: 4px;
  color: var(--cps-color-primary-text);
}

.src-icon-input-icon-input-styles__withLeftIcon {
  padding-left: 42px;
}

.src-icon-input-icon-input-styles__withRightIcon {
  padding-right: 42px;
}

.src-icon-input-icon-input-styles__mobileInput > input {
  height: 48px;
  font-size: 16px;
  padding-top: 0px;
  padding-bottom: 0px;
  font-style: normal;
}

.src-icon-input-icon-input-styles__mobileInput > input::placeholder {
  font-style: normal;
}

.src-icon-input-icon-input-styles__mobileHeight {
  height: 48px;
}

.src-icon-input-icon-input-styles__mobileIcon {
  padding-top: 12px;
}

input:focus + .src-icon-input-icon-input-styles__mobileIcon > cps-icon {
  color: var(--cps-color-primary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/icon-input/icon-input.styles.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,MAAM;EACN,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,MAAM;EACN,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".leftIcon {\n  left: 12px;\n  top: 0;\n  position: absolute;\n  z-index: 2;\n  padding-top: 4px;\n}\n\n.rightIcon {\n  right: 12px;\n  top: 0;\n  position: absolute;\n  z-index: 2;\n  padding-top: 4px;\n  color: var(--cps-color-primary-text);\n}\n\n.withLeftIcon {\n  padding-left: 42px;\n}\n\n.withRightIcon {\n  padding-right: 42px;\n}\n\n.mobileInput > input {\n  height: 48px;\n  font-size: 16px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  font-style: normal;\n}\n\n.mobileInput > input::placeholder {\n  font-style: normal;\n}\n\n.mobileHeight {\n  height: 48px;\n}\n\n.mobileIcon {\n  padding-top: 12px;\n}\n\ninput:focus + .mobileIcon > cps-icon {\n  color: var(--cps-color-primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftIcon": `src-icon-input-icon-input-styles__leftIcon`,
	"rightIcon": `src-icon-input-icon-input-styles__rightIcon`,
	"withLeftIcon": `src-icon-input-icon-input-styles__withLeftIcon`,
	"withRightIcon": `src-icon-input-icon-input-styles__withRightIcon`,
	"mobileInput": `src-icon-input-icon-input-styles__mobileInput`,
	"mobileHeight": `src-icon-input-icon-input-styles__mobileHeight`,
	"mobileIcon": `src-icon-input-icon-input-styles__mobileIcon`
};
export default ___CSS_LOADER_EXPORT___;
